var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{ref:"passengers",attrs:{"url":_vm.api.ACTIONS.PASSENGERS,"perPage":'25',"enable-add":false,"enable-edit":false,"enable-delete":false,"formatter":_vm.formatter,"actions-extra-main":_vm.actions,"conditional-action":_vm.conditionalActions,"initial-url-search-params":_vm.typeParams,"fields-hidden-main":[
    'type',
    'approved_at',
    'username',
    'active',
    'establishment_name',
    'birthday',
    'gender',
    'account_state'
  ],"titles":_vm.titles,"title":_vm.$t("businessPage.registeredTitle")}})
}
var staticRenderFns = []

export { render, staticRenderFns }